import styled from 'styled-components';

const MOBILE_HEADER_BACK_BUTTON_DIAMETER = 30; // In px


export const MobileAppHeaderContainer = styled.header`
    width: 100%;
    height: 60px;
    background: ${({ $backgroundColour }) => $backgroundColour};
    grid-area: mobile-app-header;
    padding: 10px;
    ${({ $layout }) => {
        switch ($layout) {
            case 'custom':
                return '';
            default:
                return `
                    display: grid;
                    grid-template-columns: ${MOBILE_HEADER_BACK_BUTTON_DIAMETER}px minmax(0, 1fr) minmax(${MOBILE_HEADER_BACK_BUTTON_DIAMETER}px, auto);
                    grid-template-rows: auto;
                    grid-template-areas: "back-button content .";
                    gap: 15px;
                    align-items: center;
                `;
        }
    }}
    color: ${({ $textColour }) => $textColour};
    overflow: hidden;
    ${({ $hide }) => $hide ? 'display: none;' : ''}
`;

MobileAppHeaderContainer.displayName = 'MobileAppHeaderContainer';


export const CustomContentsContainer = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

CustomContentsContainer.displayName = 'CustomContentsContainer';




export const HeaderBackButton = styled.button`
    width: ${MOBILE_HEADER_BACK_BUTTON_DIAMETER}px;
    height: ${MOBILE_HEADER_BACK_BUTTON_DIAMETER}px;
    background: none;
    padding: 0;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    color: inherit;
    cursor: pointer;

    &:disabled {
        opacity: 0;
    }

    svg {
        width: auto;
        height: 60%;
    }
`;

HeaderBackButton.displayName = 'HeaderBackButton';


export const HeaderText = styled.h1`
    margin: 0;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.5em;
    color: inherit;
`;

HeaderText.displayName = 'HeaderText';